<script>

import Swal from "sweetalert2";
import moment from "moment/moment";

export default {
  setup() {
    return { };
  },
  components: {

  },
  props: {
    tabPrecosList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    updating: {
      type: Boolean,
    },
  },
  mounted() {
    // console.log('mounted tabprecos-table_0')
    // console.log(this.updating)
  },
  methods: {
    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    detalhes(idData){
      console.log('detalhes_0: ' + idData)
      this.$router.push(`/tabpreco/detalhe/${idData}`);

    },

    editar(idData){
      console.log('editar: ' + idData)
      this.$router.push(`/tabpreco/editar/${idData}`)
    },

    deletar(idData){
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.$emit('deletareg', idData)
        }
      })
    },
    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },
    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },
    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

  },
  data() {
    return {
      regSelecionado: {},

    };
  },
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap">
      <thead class="table-light">
      <tr>
        <th class="align-middle">ID</th>
        <th class="align-middle">Código</th>
        <th class="align-middle">Descrição</th>
        <th class="align-middle">Unidade</th>
        <th class="align-middle">Status</th>
        <th class="align-middle">Atividade</th>
        <th class="align-middle">Início Vigência</th>
        <th class="align-middle">Fim Vigência</th>
        <th class="align-middle">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in tabPrecosList" :key="data.id">

        <td>
          <a href="javascript: void(0);" class="text-body fw-bold" @click="editar(data.id)">
            #{{ data.id }}
          </a>
        </td>
        <td>

          <div class="avatar-xs">
            <span class="avatar-title rounded-circle">{{data.codigo.substring(0, 3)}}</span>
          </div>

        </td>
        <td>{{ data.descricao }} </td>
        <td>{{ data.unidade }} </td>
        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.status === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                {{ nomeStatus(data.status)  }}
              </span>
        </td>
        <td>
          <div>
            <a
                href="javascript: void(0);"
                class="badge badge-soft-primary font-size-11 m-1"
            >{{data.tags[0]}}</a>
            <a
                href="javascript: void(0);"
                class="badge badge-soft-primary font-size-11 m-1"
            >{{data.tags[1]}}</a>
            <a
                href="javascript: void(0);"
                class="badge badge-soft-primary font-size-11 m-1"
            >{{data.tags[2]}}</a>
          </div>
        </td>
        <td> {{ formatDate(data.created_at) }}</td>
        <td>{{ formatDate(data.created_at) }} </td>


        <td>
          <div class="button-items">

            <b-button variant="outline-warning" @click="editar(data.id)" :disabled="data.email === 'admin@admin.com.br'">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>

            <b-button variant="outline-danger" @click="deletar(data.id)" :disabled="data.email === 'admin@admin.com.br'">
              <i class="mdi mdi-trash-can d-block font-size-16"></i>
            </b-button>

          </div>
        </td>


      </tr>
      </tbody>
    </table>


  </div>

</template>
